import React, { Component } from "react";
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import utilsScript from 'intl-tel-input/build/js/utils.js';
import { ToastContainer, toast } from 'react-toastify';
import LoadingIndicatorComponent from "../utils/loadingIndicator";
import 'react-toastify/dist/ReactToastify.css';
import axios from 'axios';

class UserDataInputComponent extends Component {

    state = {
        uslugeDict : {
            "sisanje": "Šišanje",
            "sisanjebrada": "Šišanje i sređivanje brade",
            "brada": "Sređivanje brade"
          },
        frizeriDict : {
            "frizer1": "Jovan",
            "frizer2": "Aleksandar"
          },
        errorName: null,
        errorPhone: null,
        errorEmail: null
    }

    constructor(props){  
        super(props);
        this.state.parametriZakazanogTermina = {}

        this.state.parametriZakazanogTermina["datum"] = this.props.currentInformation.dateChosen;
        this.state.parametriZakazanogTermina["usluga"] = this.props.currentInformation.serviceChosen;
        this.state.parametriZakazanogTermina["frizer"] = this.props.currentInformation.barberChosen;
    } 

    componentDidMount() {
        this.initializePhoneField();
    }

    timestampToDateString = function(timestamp) {
        var date = new Date(+timestamp*1000);
        var dan = date.getDate();
        var mesec = date.getMonth()+1;
        var godina = date.getFullYear();
        var sat = date.getHours();
        var minut = date.getMinutes();
    
        return dan+"."+mesec+"."+godina+" u "+sat+"."+(minut<=9? "0"+minut: minut )+"h";
      };

      initializePhoneField(){
        const phoneInputField = document.querySelector("#phone");
        this.state.phoneInput = intlTelInput(phoneInputField, {
            // any initialisation options go here
            preferredCountries: ["rs", "ba", "hr", "me", "mk" ,"si", "de", "at", "ch"],
            nationalMode: true,
            utilsScript: utilsScript
        });
      }

      validirajPodatke = () => {
        const nameField = document.querySelector("#contact-full-name");
        const emailField = document.querySelector("#contact-email");
        const phoneInputField = document.querySelector("#phone");

        // validiraj uneto ime
        if(!nameField.value || nameField.value.trim().length == 0){
            let errorMess = "Niste uneli svoje ime.";
            toast.error(errorMess);
            this.setState({errorName: errorMess});
            nameField.scrollIntoView({behavior:"smooth", block: "center", inline:"nearest"});
           return false;
         }
        // validiraj broj telefona
         if(!this.state.phoneInput.isValidNumber()) {
          let errorMess = "Broj telefona koji ste uneli nije u odgovarajućem formatu.";
            toast.error(errorMess);
            this.setState({errorPhone: errorMess});
            phoneInputField.scrollIntoView({behavior:"smooth", block: "center", inline:"nearest"});
           return false;
         }
        // validiraj email
         if (!emailField.value || !this.validateEmail(emailField.value)) {
            let errorMess = "Email adresa koju ste uneli nije u odgovarajućem formatu.";
            this.setState({errorEmail: errorMess});
            toast.error(errorMess);
            emailField.scrollIntoView({behavior:"smooth", block: "center", inline:"nearest"});
           return false;
         }
        return true;
      };

      validateEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
    
      potvrdiRezervaciju = () => {
        document.querySelector('#confirmButton').disabled = true;
        var podaciValidni = this.validirajPodatke();
        if(podaciValidni){
            let userDataObject = {
                usluga: this.props.currentInformation.serviceChosen,
                frizer: this.props.currentInformation.barberChosen,
                datum: this.props.currentInformation.dateChosen,
                ime: document.querySelector("#contact-full-name").value,
                telefon: this.state.phoneInput.getNumber(),
                email: document.querySelector("#contact-email").value
            }
            
            axios.post("/api/create_booking/", userDataObject)
            .then(response => {
                if(response.data["status_code"]==200){
                    toast.success("Vaš termin je uspešno kreiran.");
                    let URLParams = "?email="+encodeURIComponent(document.querySelector("#contact-email").value)+"&phone="+encodeURIComponent(this.state.phoneInput.getNumber());
                    response.statusZakazivanjaNaslov = "Hvala Vam, <br/> Vaš termin je uspešno zakazan!";
                    response.statusZakazivanjaTekst ="Sve informacije o Vašem terminu su poslate na Vaš mejl. <br/><br/> U slučaju da želite da otkažete svoju rezervaciju, to možete uraditi klikom na <b><a href='/mojitermini"+URLParams+"'>LINK</a></b> ili se obratite na <a href='tel:+381628796883'>+381 62 879 6883</a>.";
                }
                else{
                    document.querySelector('#confirmButton').disabled = false;
                    response.statusZakazivanjaNaslov = "Došlo je do problema";
                    response.statusZakazivanjaTekst = response.data["message"];
                    toast.error(response.data["message"]);
                }
                
                this.props.onUserDataInput(response);
            })
            .catch(function (error) {
              toast.error("Greška u komunikaciji. Molimo vas da pokušate kasnije.");
              document.querySelector('#confirmButton').disabled = false;
              toast.error(error.response.data.message);
            });
        }
        else{
          document.querySelector('#confirmButton').disabled = false;
        }
      };
    
    promeniPoljeZaUnos = (event) => {
      if(event.target.id==="contact-full-name" && this.state.errorName){
        this.setState({errorName:null});
      }

      if(event.target.id==="phone" && this.state.errorPhone){
      this.setState({errorPhone:null});
      }

      if(event.target.id==="contact-email" && this.state.errorEmail){
      this.setState({errorEmail:null});
      }
    }
      
    render() { 
        return (  
            <section className="section-xl bg-periglacial-blue one-screen-page-content text-center">
            <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            />
            <div className="shell">
              <h2>Još samo jedan korak!</h2>
              <div className="p text-width-medium">
                <p className="big">Da biste potvrdili svoj termin, popunite preostala polja ispod.</p>
              </div>
              <div
                className="box-contacts box-contacts-vertical box-contacts-vertical-small box-wrap-content-interactive block-centered">
                <div className="box-contacts-col">
                  <div className="box-contacts-block">
                    <h3><a className="icon icon-xs link-gray-light fa-scissors"></a> Usluga</h3>
                    <h4>{this.state.uslugeDict[this.state.parametriZakazanogTermina.usluga]}</h4>
                  </div>
                  <div className="box-contacts-block">
                    <h3><a className="icon icon-xs link-gray-light fa-user"></a> Frizer</h3>
                    <h4>{this.state.frizeriDict[this.state.parametriZakazanogTermina.frizer]}</h4>
                  </div>
                  <div className="box-contacts-block">
                    <h3><a className="icon icon-xs link-gray-light fa-clock-o"></a> Termin</h3>
                    <h4>{this.timestampToDateString(this.state.parametriZakazanogTermina.datum)}</h4>
                  </div>
                </div>
                <div className="box-contacts-col box-contacts-right">
                  <div className="box-contacts-block">
                    
                      <div className="form-group">
                        <label className="form-label-outside" htmlFor="contact-full-name">Ime i prezime</label>
                        <input className="form-control" id="contact-full-name" type="text" name="name" onChange={(e) => {this.promeniPoljeZaUnos(e)}} style={this.state.errorName!=null?{borderColor:"red"}:{borderColor:"#cfdbd5"}}/>
                        {this.state.errorName!=null && <div style={{color:"red"}}>{this.state.errorName}</div>}
                      </div>
                      <div className="form-group">
                        <label className="form-label-outside" htmlFor="phone">Broj telefona</label>
                        <input id="phone" className="form-control" name="phone" type="tel" onChange={(e) => {this.promeniPoljeZaUnos(e)}} style={this.state.errorPhone!=null?{borderColor:"red", width:"100%"}:{borderColor:"#cfdbd5", width:"100%"}}/>
                        {this.state.errorPhone!=null && <div style={{color:"red"}}>{this.state.errorPhone}</div>}
                      </div>
                      <div className="form-group">
                        <label className="form-label-outside" htmlFor="contact-email">Email</label>
                        <input className="form-control" id="contact-email" type="email" name="email"
                          data-constraints="@Email" onChange={(e) => {this.promeniPoljeZaUnos(e)}} style={this.state.errorEmail!=null?{borderColor:"red"}:{borderColor:"#cfdbd5"}}/>
                        {this.state.errorEmail!=null && <div style={{color:"red"}}>{this.state.errorEmail}</div>}
                      </div>
                      <button id="confirmButton" className="btn btn-sm btn-primary btn-block btn-circle" onClick={this.potvrdiRezervaciju}>Potvrdi</button>
          
                  </div>
                </div>
              </div>
          
            </div>
            
          </section>
          
      );
    }
}
 
export default UserDataInputComponent;